<template>
	<div class="container__booking container__single" v-if="!loading">
		<section class="form__vertical booking-form form">
			<component v-for="(step, i) in steps" :is="step.component" :key="i" />
		</section>
	</div>
</template>

<script>
import bookingMixin from './mixins/booking.mixin'
import Service from './components/service'
import Addons from './components/addons'
import Barber from './components/barber'
import Term from './components/term'
import PersonalData from './components/personalData'

export default {
	name: 'Booking',

	layout: 'booking',

	mixins: [bookingMixin],

	components: {
		Barber,
		Service,
		Addons,
		Term,
		PersonalData,
	},

	metaInfo() {
		return { title: this.$t('pages.booking') }
	},
}
</script>
